import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { getCachedSvgDataURI } from '../../lib/svgCache'

/**
 * CachedSvg - Renders an SVG component using cached blob URLs
 * This prevents React from re-rendering SVG components thousands of times
 * 
 * @param {React.Component} component - The SVG React component to render
 * @param {string} componentName - Unique name for the component (for cache key)
 * @param {object} svgProps - Props to pass to the SVG component
 * @param {string} alt - Alt text for the img tag
 * @param {number} width - Width of the image
 * @param {number} height - Height of the image
 */
function CachedSvg({ component, componentName, svgProps = {}, alt = '', width, height, ...imgProps }) {
  const blobUrl = useMemo(() => {
    return getCachedSvgDataURI(component, componentName, svgProps)
  }, [component, componentName, JSON.stringify(svgProps)])

  return (
    <img 
      alt={alt} 
      height={height}
      src={blobUrl} 
      width={width} 
      {...imgProps}
    />
  )
}

CachedSvg.propTypes = {
  component: PropTypes.elementType.isRequired,
  componentName: PropTypes.string.isRequired,
  svgProps: PropTypes.object,
  alt: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default CachedSvg
